<div mat-dialog-title>
	<div class="d-flex justify-content-between">
		<h4>Top Count Requests</h4>
		<span mat-dialog-close><i class="fa fa-times"></i></span>
	</div>
</div>
<mat-dialog-content class="mat-typography">
	<div
		class="table-responsive dropdownyes customResponsive tablefields"
		*ngIf="dataList"
	>
		<table border="1" class="table CustomTable">
			<thead>
				<tr>
					<th>#</th>
					<th>{{ "lang_request_number" | language }}</th>
					<th>{{ "lang_platform_title" | language }}</th>
					<th>{{ "lang_platform_code_system" | language }}</th>
					<th>{{ "lang_result" | language }}</th>
					<th>{{ "lang_group_one" | language }}</th>
					<th>{{ "lang_group_two" | language }}</th>
					<th>{{ "lang_unit" | language }}</th>
					<th>{{ "lang_level" | language }}</th>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="
						let item of dataList?.records;
						let i = index;
						let odd = odd;
						let even = even
					"
				>
					<td>{{ i + 1 }}</td>
					<td
						class="link-to-popup"
						(click)="
							onMoveToRequest(
								item?.transaction_key,
								item?.transaction_request_id
							)
						"
					>
						{{ item?.transaction_request_id || "---" }}
					</td>
					<td>{{ item?.platform_name }}</td>
					<td>{{ item?.platform_code_system }}</td>
					<td>{{ item?.result_code || "---" }}</td>
					<td>{{ item?.group1_name }}</td>
					<td>{{ item?.group2_name }}</td>
					<td>{{ item?.unit_id }}</td>
					<td>{{ item?.level_name }}</td>
				</tr>
			</tbody>
		</table>
		<div
			class="col-12 mt-2"
			style="
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
			"
			*ngIf="dataList?.records?.length > 0"
		>
			<p>
				{{ "lang_total" | language }}:
				{{ dataList?.pages?.total_records }}
			</p>
			<ngb-pagination
				[collectionSize]="dataList?.pages?.total_records"
				[rotate]="true"
				[maxSize]="3"
				[boundaryLinks]="true"
				[(page)]="page_no"
				[pageSize]="page_size"
				(pageChange)="getList()"
			></ngb-pagination>
			<mat-select
				class="customselect"
				[(ngModel)]="page_size"
				(selectionChange)="getList()"
				style="width: 120px"
			>
				<mat-option [value]="10"
					>10 {{ "lang_per_page" | language }}</mat-option
				>
				<mat-option [value]="50"
					>50 {{ "lang_per_page" | language }}</mat-option
				>
				<mat-option [value]="100"
					>100 {{ "lang_per_page" | language }}</mat-option
				>
				<mat-option [value]="200"
					>200 {{ "lang_per_page" | language }}</mat-option
				>
				<mat-option [value]="400"
					>400 {{ "lang_per_page" | language }}</mat-option
				>
				<mat-option [value]="500"
					>500 {{ "lang_per_page" | language }}</mat-option
				>
			</mat-select>
		</div>
	</div>
	<div class="mt-3 mb-3 text-center" *ngIf="!dataList">
		<p style="font-size: 18px">{{ dataList_msg }}</p>
	</div>
</mat-dialog-content>
